import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../api/api";
import "./Auth.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const redirect = location.state?.redirect || "/";

  // Check if user is already logged in
  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = localStorage.getItem("user");

    if (token && user) {
      const userData = JSON.parse(user);
      // Redirect based on role
      if (userData.role === "Admin") {
        navigate("/admin", { replace: true });
      } else if (userData.role === "Staff") {
        navigate("/staff", { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    }
  }, [navigate]);

  const handleLogin = async () => {
    try {
      const res = await api.post("/users/login", { email, password });

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));

      // 🔔 notify navbar
      window.dispatchEvent(new Event("auth-change"));

      // Check Role
      if (res.data.user.role === "Admin") {
        navigate("/admin");
      } else if (res.data.user.role === "Staff") {
        navigate("/staff");
      } else {
        navigate(redirect);
      }
    } catch {
      alert("Invalid login credentials");
    }
  };



  return (
    <div className="auth-page fade-in">
      <h2>Login</h2>

      <input placeholder="Email" onChange={e => setEmail(e.target.value)} />
      <input
        type="password"
        placeholder="Password"
        onChange={e => setPassword(e.target.value)}
      />

      <button onClick={handleLogin} className="btn-animate">Login</button>
    </div>
  );
};

export default Login;
